import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import SEO from "@/components/SEO";
import { GENERAL_DISCLOSURE } from "@/data/siteContent";

const SECTIONS = [
  {
    title: "This Website Is Educational",
    body: [
      "The content on this website is provided for general educational purposes only. It is not insurance, financial, legal, or tax advice, and it does not create an agent-client relationship. The terms of any policy are governed solely by the policy contract issued by the insurance company.",
    ],
  },
  {
    title: "No Guarantee of Coverage",
    body: [
      GENERAL_DISCLOSURE,
      "Submitting a form on this website does not begin coverage, bind coverage, or constitute an application for insurance.",
    ],
  },
  {
    title: "Quotes and Estimates",
    body: [
      "Any quote or estimate provided is preliminary and subject to underwriting by the issuing insurance company. Final rates and eligibility depend on the carrier's review of a completed application.",
    ],
  },
  {
    title: "Intellectual Property",
    body: [
      "The content, design, and branding of this website belong to 1907 Insurance Group. Carrier names and logos are the property of their respective owners and are displayed to identify companies the agency works with.",
    ],
  },
  {
    title: "Acceptable Use",
    body: [
      "You agree not to misuse this website, including by submitting false information, attempting to access systems without authorization, or using automated tools to submit forms.",
    ],
  },
  {
    title: "Limitation of Liability",
    body: [
      "To the fullest extent permitted by law, 1907 Insurance Group is not liable for damages arising from the use of this website or reliance on its educational content.",
    ],
  },
  {
    title: "Contact",
    body: [
      "Questions about these terms may be directed to (877) 833-1907 or the contact form on this website.",
    ],
  },
];

export default function Terms() {
  return (
    <>
      <SEO title="Terms of Use | 1907 Insurance Group" description="Terms governing the use of the 1907 Insurance Group website." />
      <PageHero eyebrow="Terms of Use" title="The Ground Rules for This Website"
        intro="Draft pending legal review. By using this website, you agree to the following terms. Effective date: [TO BE SET AT LAUNCH]." />
      <section className="py-16 md:py-24" data-testid="terms-content">
        <div className="container-site max-w-3xl space-y-12">
          {SECTIONS.map((s) => (
            <Reveal key={s.title}>
              <h2 className="text-2xl tracking-tight">{s.title}</h2>
              {s.body.map((p, i) => <p key={i} className="mt-4 text-lg text-mutedink leading-relaxed">{p}</p>)}
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
}
